import React, { useEffect, useState } from "react";
import { trendingCategoryData } from "../../data/categories_data";
import Collection_category_filter from "../collectrions/collection_category_filter";
import CategoryItem from "./categoryItem";
import { useDispatch, useSelector } from "react-redux";
import { updateTrendingCategoryItemData } from "../../redux/counterSlice";
import { useRouter } from "next/router";
import { useCollectionItemsQuery } from "../../redux/actions/collection";
import { Spin } from "antd";
import NFTCard from "../cards/NFTCard";
import Error from "../errors/Error";
import NFTCardSlider from "../cards/NFTCardSlider";
import useTranslation from "next-translate/useTranslation";

const FilterCategoryItem = () => {
  const {t, lang} = useTranslation('collection')
  const dispatch = useDispatch();
  const { query } = useRouter();

  const [SaleType, setSaleType] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [offset, setOffset] = useState(0);

  const loginDetails = useSelector((state) => state.counter.loginDetails);


  const { data, isFetching, isError, error } = useCollectionItemsQuery({
    collectionId: query?.collection,
    saleType: SaleType,
    orderBy: sortBy,
    offset: offset,
    user_id: loginDetails?.profile?.id || '',
  })
  console.log(data)
  useEffect(() => {
    dispatch(updateTrendingCategoryItemData(trendingCategoryData.slice(0, 8)));
  }, []);

  return (
    <Spin spinning={isFetching} tip="Loading...">
      {/* <!-- Filter --> */}
      <Collection_category_filter setSaleType={(data) => setSaleType(data)} setSortBy={(data) => setSortBy(data)} />
      {data?.status ? data?.data?.length === 0 ?
        <Error msg='This collection dont have any nft items' />
        :
        // <NFTCard data={data} />

        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4">
          {data?.data?.length !== 0 && data?.data?.map((item) => {
            return (
              <NFTCardSlider item={item} />
            );
          })}
        </div>
        :
        <Error msg={data?.message} />}

      <div className="mt-6 py-3 px-8">
        <div className="row">
          <div className="col-md-4 space-x-2 flex justify-center">
            <button disabled={offset == 0} onClick={() => setOffset(offset - 1)} className="dark:border-accent-dark/50 dark:bg-black dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border-2 hover:dark:border-accent-dark bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize">{t('prev')}</button>

            <button disabled={(data?.data?.length || 0) == 0} onClick={() => setOffset(offset + 1)} className="dark:border-accent-dark/50 dark:bg-black dark:hover:bg-accent group hover:bg-accent border-jacarta-100 font-display text-jacarta-500 flex h-9 items-center rounded-lg border-2 hover:dark:border-accent-dark bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:text-white capitalize">{t('next')}</button>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default FilterCategoryItem;
